import React, { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';

const BeforeAfterSlider = ({ beforeImage, afterImage, beforeLabel = "Før", afterLabel = "Efter" }) => {
  const [sliderPosition, setSliderPosition] = useState(50);
  const containerRef = useRef(null);

  const handleMove = (event) => {
    if (!containerRef.current) return;

    const rect = containerRef.current.getBoundingClientRect();
    const x = event.pageX || (event.touches && event.touches[0].pageX) || 0;
    const position = ((x - rect.left) / rect.width) * 100;

    if (position >= 0 && position <= 100) {
      setSliderPosition(position);
    }
  };

  const handleTouchMove = (e) => {
    handleMove(e);
  };

  return (
    <div 
      ref={containerRef}
      className="relative w-full aspect-[4/3] rounded-3xl overflow-hidden cursor-ew-resize select-none"
      onMouseMove={handleMove}
      onTouchMove={handleTouchMove}
    >
      {/* After Image (Background) */}
      <img
        src={afterImage}
        alt="Efter behandling"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Before Image (Foreground with Clip Path) */}
      <div 
        className="absolute inset-0 w-full h-full"
        style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}
      >
        <img
          src={beforeImage}
          alt="Før behandling"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>

      {/* Slider Line & Handle */}
      <div 
        className="absolute inset-y-0 w-1 bg-white shadow-xl flex items-center justify-center"
        style={{ left: `${sliderPosition}%`, transform: 'translateX(-50%)' }}
      >
        <div className="w-10 h-10 bg-white rounded-full shadow-2xl flex items-center justify-center group">
          <div className="flex gap-1">
             <div className="w-1 h-3 bg-stone-300 rounded-full group-hover:bg-orange-400 transition-colors" />
             <div className="w-1 h-3 bg-stone-300 rounded-full group-hover:bg-orange-400 transition-colors" />
          </div>
        </div>
      </div>

      {/* Labels */}
      {beforeLabel && (
        <div className="absolute top-6 left-6 pointer-events-none">
          <span className="bg-white/90 backdrop-blur px-4 py-2 rounded-full text-[10px] uppercase tracking-widest font-bold shadow-sm">
            {beforeLabel}
          </span>
        </div>
      )}
      {afterLabel && (
        <div className="absolute top-6 right-6 pointer-events-none">
          <span className="bg-stone-900 text-white px-4 py-2 rounded-full text-[10px] uppercase tracking-widest font-bold shadow-sm">
            {afterLabel}
          </span>
        </div>
      )}
    </div>
  );
};

export default BeforeAfterSlider;
